import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../common/Routes";
import { isNullOrUndefined } from "../../../../../common/utils";
import { errorMsg } from "../../../../../components/simpleMessageAlert";
import useGetUserListApiCallStatus from "../../../userList/hooks/GetUserListApiCallStatus/GetUserListApiCallStatus";
import useGetUserDetail from "../GetUserDetail/GetUserDetail";

function useHandleUserNotFound(isApiCallMade, id) {
  const history = useHistory();
  const { userListApiCallProgress, userListApiCallError } = useGetUserListApiCallStatus();
  const userDetail = useGetUserDetail(id);

  useEffect(() => {
    const isUserNotFound =
      !userListApiCallProgress &&
      isNullOrUndefined(userDetail) &&
      isApiCallMade &&
      !userListApiCallError;
    if (isUserNotFound) {
      history.push(Routes.NotFound.path);
      errorMsg(`User with id ${id} not found`);
    }
  }, [userListApiCallProgress]);
}

export default useHandleUserNotFound;
